import { JsonProperty } from "../../../models/utilities/json-property";
import { AssetStatus } from "../enums/asset-status";
import { AssetType } from "../enums/asset-type";
import { TractorMake } from "../enums/tractor-make";
import { TractorType } from "../enums/tractor-type";
import { TrailerMake } from "../enums/trailer-make";
import { TrailerType } from "../enums/trailer-type";

/**
 * The base Asset class
 */
export class AssetRead {

    public id               : number = 0;
    
    public type             : AssetType;
    
    public status           : AssetStatus = -1;
    
    public serviceCenterId  : string = '';
    
    public name             : string = '';

    public year             : number = 0;

    public axleCount        : number = 0;

    public vin              : string = '';

    public licensePlateState : string = '';

    public licensePlateNumber : string = '';

    @JsonProperty({ toType: 'date' })
    public inServiceDate : Date|undefined = undefined;

    @JsonProperty({ toType: 'date' })
    public outOfServiceDate : Date|undefined = undefined;

    public rowVersion       : string = '';

}

        export class TrailerRead extends AssetRead {

            public trailerMake : TrailerMake = TrailerMake.Unknown;

            public trailerType : TrailerType = TrailerType.Unknown;

            constructor() {
                super();
                this.type = AssetType.Trailer;
            }

        }

        export class TractorRead extends AssetRead {

            public tractorMake : TractorMake = TractorMake.Uknown;

            public tractorType : TractorType = TractorType.Unknown;

            constructor() {
                super();
                this.type = AssetType.Tractor;
            }

        }

        export class BoxTruckRead extends AssetRead {

            constructor() {
                super();
                this.type = AssetType.BoxTruck;
            }

        }
